import React from 'react';

function FlyersIcon(props) {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='1em'
      height='1em'
      viewBox='0 0 20.262 21'
      {...props}
    >
      <defs>
        <style>{'.prefix__a{fill:#fff}'}</style>
      </defs>
      <path
        className='prefix__a subheader__container-link-icon'
        d='M18.416 5.947H1.846A1.848 1.848 0 000 7.793v7.383a1.848 1.848 0 001.846 1.846h16.57a1.848 1.848 0 001.846-1.846V7.793a1.848 1.848 0 00-1.846-1.846zM4.87 12.441h-.678v1.419a.615.615 0 01-1.23 0l-.009-4.674a.615.615 0 01.615-.617h1.3a1.935 1.935 0 110 3.869zm5.281 1.888c-.366.006-1.283.01-1.322.01a.615.615 0 01-.615-.613l-.009-4.538a.615.615 0 01.615-.616h1.28c1.464 0 2.447 1.159 2.447 2.884a2.608 2.608 0 01-2.395 2.874zm6.3-3.528a.615.615 0 110 1.23H15.34v1.749a.615.615 0 11-1.23 0V9.139a.615.615 0 01.615-.615h1.881a.615.615 0 010 1.23H15.34V10.8z'
      />
      <path
        className='prefix__a subheader__container-link-icon'
        d='M10.108 9.803h-.669c0 .555 0 2.769.006 3.3.256 0 .53 0 .69-.007.822-.014 1.19-.836 1.19-1.643-.004-.384-.092-1.65-1.217-1.65zM4.87 9.803h-.685v1.407h.681a.704.704 0 100-1.408zM17.779 4.717a3.07 3.07 0 00-.657-1.061L14.566.96A3.089 3.089 0 0012.333 0h-8.19a1.848 1.848 0 00-1.846 1.846v2.871zM2.297 18.252v.9a1.848 1.848 0 001.846 1.846h11.976a1.848 1.848 0 001.846-1.846v-.9z'
      />
    </svg>
  );
}

export default FlyersIcon;
